/* globals Wistia */
import $ from 'jquery';

/**
 * Handles Wistia background videos.
 *
 * USAGE:
 * All you need is one <div> and the site's JS will handle the rest.
 * <div id="{{ wistia_video_id }}" data-video="{{ wistia_video_id }}" data-fullscreen="true" class="wistia_embed"></div>
 *
 * The 'data-fullscreen' attribute enables the Wistia Crop Fill plugin which
 * keeps the video the full size of the viewport.
 */

const SELECTOR = '[data-background-video]';

function embedVideo(id, videoOptions) {
	const backgroundVideoDiv = $(`#wistia_${id}`);

	// Embeds video.
	const wistiaEmbed = Wistia.embed(id, videoOptions);

	/**
	 * Waits for the video to load and play.
	 * Once loaded, we pause, reset to frame zero, show the video then play it.
	 */
	wistiaEmbed.bind('play', function () {
		wistiaEmbed.pause();
		wistiaEmbed.time(0);
		backgroundVideoDiv.css('opacity', 1);
		wistiaEmbed.play();
		return this.unbind;
	});
}

let doNotTrack = false;

function onDocumentReady() {
	// Respect browser "Do Not Track" request.
	// Used to disable Wistia analytics tracking.
	if (navigator.doNotTrack === '1') {
		doNotTrack = true;
	}

	$(SELECTOR).each(initializeElement);
}

function initializeElement(i, el) {
	const id = el.getAttribute('data-background-video');

	const bgVideo = $(`
		<div id="wistia_${id}" data-fullscreen="true" class="wistia_embed background-video"></div>
	`);
	$(el).prepend(bgVideo);

	const videoOptions = {
		autoPlay: true,
		controlsVisibleOnLoad: false,
		endVideoBehavior: 'loop',
		fullscreenButton: false,
		muted: true,
		playbar: false,
		playButton: false,
		qualityControl: false,
		qualityMax: 1080,
		seo: false,
		settingsControl: false,
		silentAutoPlay: true,
		volumeControl: false,
		doNotTrack,
	};

	// Adds the Crop Fill plugin if fullscreen.
	if (bgVideo.attr('data-fullscreen') === 'true') {
		Wistia.obj.merge(videoOptions, {
			plugin: {
				cropFill: {
					src: '//fast.wistia.com/labs/crop-fill/plugin.js',
				},
			},
		});
	}

	embedVideo(id, videoOptions);
}

document.addEventListener('DOMContentLoaded', onDocumentReady);

